import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader, 
  showSuccessMessage,
  showErrorMessage,
  showWarningMessage,
} from './../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  showErrorMessage,
  API_URL,
  showWarningMessage,
};
export const CUSTOMFIELDAPI = `${API_URL}/master-custom-label`;
export const GET_CUSTOM_FIELDS_LIST_API = `${API_URL}/MasterCustomLabels/GetCustomLabel`;
export const POST_CUSTOM_FIELD_API = `${API_URL}/MasterCustomLabels/SaveCustomLabel`;
export const GET_CUSTOM_FIELD_DETAILS_API = `${API_URL}/MasterCustomLabels/GetCustomLabelById`;
export const DELETE_CUSTOM_FIELD_API = `${API_URL}/MasterCustomLabels/DeleteCustomLabel`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const customFieldActionTypes = {
  get_masterdata: createRequestActionTypes('GET_MASTER_DATA'),
  get_custom_field: createRequestActionTypes('GET_CUSTOM_FIELD'),
  post_custom_field: createRequestActionTypes('POST_CUSTOM_FIELD'),
  delete_custom_field: createRequestActionTypes('DELETE_CUSTOM_FIELD'),

  get_customFieldsList: createRequestActionTypes('GET_CUSTOMFIELDSLIST'),
  post_customField: createRequestActionTypes('POST_CUSTOMFIELD'),
  get_customFieldDetails: createRequestActionTypes('GET_CUSTOMFIELDDETAILS'),
  delete_customField: createRequestActionTypes('DELETE_CUSTOMFIELD'),
};

export const MODULE = 'MASTER_CUSTOMLABEL';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/customFields/constants/ApiConstants.js